import { render, staticRenderFns } from "./ServiceContainer.vue?vue&type=template&id=d9bd50a6&scoped=true"
import script from "./ServiceContainer.vue?vue&type=script&lang=js"
export * from "./ServiceContainer.vue?vue&type=script&lang=js"
import style0 from "./ServiceContainer.vue?vue&type=style&index=0&id=d9bd50a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bd50a6",
  null
  
)

export default component.exports